import React from 'react';

import type { AccountsListColumn, ColumnComponentProps } from './accounts-list-table';

import { AccountScoreBadge } from '../admin/account-score-badge';
import { AccountStatusTransitions } from '../admin/admin-panel/account-status-transitions/account-status-transitions';
import { CarrierRegistrationIcon } from '../admin/carrier-registration-icon';

import { AccountsListOrgLink } from './accounts-list-org-link';

import { ACCOUNT_STATUS_CONFIG } from '../util/account-status';
import { formatDate } from '../util/formatters';
import { SORT_ORDER, sortAlphabetically } from '../util/sort-functions';

export const ACCOUNT_LIST_BASIC_COLUMNS: AccountsListColumn[] = [
  {
    label: 'Account Name',
    value: 'accountName',
    ColumnComponent: ({ account }: ColumnComponentProps) => (
      <div className="typo-title">{account.accountName}</div>
    ),
  },
  {
    label: 'Organizations',
    value: 'Organizations',
    disableSorting: true,
    ColumnComponent: ({ account }: ColumnComponentProps) => (
      <>
        {account.Organizations.filter((o) => o.isActive)
          .sort(sortAlphabetically((o) => o.name, SORT_ORDER.ASC))
          .map((org) => (
            <AccountsListOrgLink key={org.org_id} org={org} />
          ))}
      </>
    ),
  },
  {
    label: 'Status',
    value: 'status',
    ColumnComponent: ({ account }: ColumnComponentProps) => (
      <span>
        {ACCOUNT_STATUS_CONFIG[account.status] ? ACCOUNT_STATUS_CONFIG[account.status].text : ''}
      </span>
    ),
  },
];

export const ACCOUNT_LIST_ADMIN_COLUMNS: AccountsListColumn[] = ACCOUNT_LIST_BASIC_COLUMNS.concat([
  {
    label: 'Created On',
    value: 'firstHistoryEntry',
    hasDateValue: true,
    ColumnComponent: ({ account }: ColumnComponentProps) => (
      <span>{formatDate(account.firstHistoryEntry, 'MMM Do YYYY')}</span>
    ),
  },
  {
    label: 'Subscribed',
    value: 'subscriptionDate',
    hasDateValue: true,
    isAdminOnly: true,
    ColumnComponent: ({ account }: ColumnComponentProps) => (
      <span>{formatDate(account.subscriptionDate, 'MMM Do YYYY')}</span>
    ),
  },
  {
    label: 'Trial Start',
    value: 'trialStartDate',
    hasDateValue: true,
    ColumnComponent: ({ account }: ColumnComponentProps) => (
      <span>{formatDate(account.trialStartDate, 'MMM Do YYYY')}</span>
    ),
  },
  {
    label: 'Account Score',
    value: 'totalScore',
    columnAlign: 'center',
    ColumnComponent: ({ account }: ColumnComponentProps) => (
      <AccountScoreBadge totalScore={account?.totalScore} />
    ),
  },
  {
    label: 'Carrier Registration',
    columnAlign: 'center',
    ColumnComponent: ({ account }: ColumnComponentProps) => (
      <CarrierRegistrationIcon
        Organizations={account.Organizations}
        twilioTrustHubBundleStatus={account.twilioTrustHubBundleStatus}
      />
    ),
  },
]);

export const ACCOUNT_BULK_STATUS_CHANGE_COLUMNS: AccountsListColumn[] =
  ACCOUNT_LIST_BASIC_COLUMNS.concat([
    {
      label: 'Created On',
      value: 'firstHistoryEntry',
      hasDateValue: true,
      ColumnComponent: ({ account }: ColumnComponentProps) => (
        <span>{formatDate(account.firstHistoryEntry, 'MMM Do YYYY')}</span>
      ),
    },
    {
      label: 'Account Status Changer',
      disableSorting: true,
      columnAlign: 'center',
      ColumnComponent: ({ account }: ColumnComponentProps) => (
        <AccountStatusTransitions accountId={account.accountId} />
      ),
    },
  ]);
